import React, { FC, ReactNode } from 'react';
import { Alert, Button, Flex, Typography } from '@duxton-web/ui';
import moment from 'moment';

import { EditButtonSection } from './EditButtonSection';
import { trimEndingSlash } from './RolloutPendingApprovalMessageUtil';
import { getDomainFamily } from '@/common/domains';
import { RolloutDiff } from '@/lib/PlannerDTOs';
import { appendEnvParam } from '@/utils/navigation';

interface PendingChangesProps {
  Diffs: RolloutDiff[];
  disabled: boolean;
  isEditRolloutButtonClicked: boolean;
  handleCancelEditButtonClicked: () => void;
  handleEditButtonClicked: () => void;
  isPendingApprovalCreator: boolean;
  isVariableOwner: boolean;
}

const getLink = function (variableName: string, id: string) {
  let link;

  link = `${
    window.location.origin
  }/${getDomainFamily()}/variables/${variableName}/rollout/approve-request/${id}`;
  trimEndingSlash(window.location.href.slice(0, -window.location.hash.length)) +
    '/approve-request/' +
    id;

  if (link.includes('/rollout/changelog'))
    link = link.replace('/rollout/changelog', '/rollout');

  return link;
};

const RolloutPendingApprovalMessage: FC<PendingChangesProps> = ({
  Diffs,
  disabled,
  isEditRolloutButtonClicked,
  handleCancelEditButtonClicked,
  handleEditButtonClicked,
  isPendingApprovalCreator,
  isVariableOwner,
}) => {
  function renderEditButtonSection(): ReactNode {
    if (isPendingApprovalCreator || isVariableOwner)
      return (
        <EditButtonSection
          isEditRolloutButtonClicked={isEditRolloutButtonClicked}
          handleCancelEditButtonClicked={handleCancelEditButtonClicked}
          handleEditButtonClicked={handleEditButtonClicked}
          disabled={disabled}
        />
      );

    return false;
  }

  return (
    <div
      style={{
        marginBottom: '20px',
      }}
    >
      <Alert
        type="warning"
        style={{ padding: 16, boxShadow: '0px 4px 9px 0px #161A1D0D' }}
        message={
          <Flex align="center">
            <Flex vertical gap={4} flex={'1 0'}>
              <Typography.Body level={3} strong type="secondary">
                Variable is pending approval for new changes and can’t be
                changed at the moment.
              </Typography.Body>
              {Diffs.map((diff) => (
                <Flex vertical gap={16} key={diff.id}>
                  <Typography.Body
                    level={3}
                    type="secondary"
                    style={{ color: '#707070' }}
                  >
                    Changes were made by {diff.createdBy} and will expire at{' '}
                    {moment(diff.expireAt).format('MMM D, YYYY h:mm A')}
                  </Typography.Body>
                  <Flex gap={4} align="center">
                    <Button
                      size="small"
                      type="primary"
                      style={{
                        background: '#e8e8e8',
                        color: '#3d3d3d',
                        border: '1px solid #E8E8E8',
                      }}
                      href={appendEnvParam(
                        getLink(diff.newRollout.variable, diff.id),
                      )}
                    >
                      Review Changes
                    </Button>
                    {renderEditButtonSection()}
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </Flex>
        }
      />
    </div>
  );
};

export default RolloutPendingApprovalMessage;
